<template>
  <div>
    <!-- start of packaaage -->
    <div v-for="(shipPackages, index) in packages" :key="index" class="mt-4">
      <div class="w-full flex flex-wrap mt-1 gap-4 pt-3 pb-2 mb-4">
        <div class="bg-gray-100 w-full py-2 px-2 flex justify-between">
          <b class="flex items-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="mr-4" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.9998 0C5.37259 0 0 5.37267 0 11.9999C0 18.6269 5.37251 24 11.9996 24C18.6268 24 23.9998 18.6269 23.9998 11.9999C23.9998 5.37267 18.6269 0 11.9998 0ZM17.0622 13.3199H13.2007V17.3574C13.2004 18.0345 12.6516 18.5833 11.9744 18.5833C11.297 18.5833 10.7482 18.0345 10.7482 17.357V13.3199H6.98945C6.31218 13.3197 5.76362 12.7709 5.76322 12.0937C5.76322 11.4167 6.31226 10.8677 6.98945 10.8675L10.7481 10.8677V7.28449C10.7481 6.60721 11.2972 6.05826 11.9742 6.05826C12.6516 6.05826 13.2007 6.60729 13.2004 7.28449L13.2007 10.8674L17.0618 10.8678C17.7391 10.8674 18.2883 11.4166 18.2881 12.094C18.2883 12.7713 17.7391 13.3199 17.0622 13.3199Z"
                fill="#E59506" />
            </svg>
            {{ isLight(shipPackages.shipmentType) ? "Light Package" : null }}
            {{ isHeavy(shipPackages.shipmentType) ? "Heavy Package" : null }}
            {{ isTruck(shipPackages.shipmentType) ? "Truck Package" : null }}
          </b>

          <span class="flex items-center">
            <svg v-if="isSubmitted[index] == true" width="24" height="24" viewBox="0 0 24 24" fill="none" class="mr-4"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.1056 0.465598C21.6825 0.229778 21.2173 0.079812 20.7363 0.0242747C20.2554 -0.0312625 19.7683 0.00871853 19.3028 0.141932C18.8373 0.275145 18.4026 0.498978 18.0235 0.800629C17.6444 1.10228 17.3284 1.47583 17.0935 1.89992L10.2518 14.2348L6.33611 10.3121C5.99616 9.95944 5.5895 9.67817 5.13988 9.48468C4.69026 9.29119 4.20667 9.18934 3.71734 9.18508C3.228 9.18082 2.74272 9.27424 2.28981 9.45987C1.8369 9.64551 1.42543 9.91965 1.0794 10.2663C0.733379 10.6129 0.459733 11.0252 0.274433 11.4789C0.0891318 11.9326 -0.00411303 12.4188 0.000139145 12.909C0.00439132 13.3992 0.106055 13.8837 0.299199 14.3341C0.492343 14.7845 0.773097 15.1919 1.12508 15.5325L8.49571 22.9164C9.19223 23.616 10.132 24 11.1012 24L11.6116 23.9631C12.1765 23.8839 12.7153 23.6745 13.1857 23.3513C13.656 23.0281 14.0451 22.5999 14.3222 22.1005L23.5355 5.48666C23.7707 5.06292 23.9203 4.59691 23.9757 4.11525C24.0312 3.63358 23.9914 3.14569 23.8586 2.67944C23.7258 2.21319 23.5027 1.7777 23.2019 1.39785C22.9011 1.01799 22.5286 0.701215 22.1056 0.465598Z"
                fill="#09B78A" />
            </svg>
            <i v-if="packages.length > 1" @click="setDeletePackageProps(index, shipPackages.id)"><remove-icon />
            </i>
          </span>
        </div>

        <div class="w-full pt-4">package dimension</div>
        <label :ifor="'noEnd' + index" class="radio-label">
          <input v-model="shipPackages.shipmentType" class="bg-primary-yellow text-secondary-yellow"
            :name="'routeEnd' + index" type="radio" :id="'noEnd' + index" value="light"
            @input="getShippingtypeValue(index, 'default')" />
          <i class="mx-2">
            <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.0487 7.90006C13.5271 7.90006 13.0365 7.62233 12.7711 7.17795L10.7868 3.88834L8.80566 7.17795C8.53718 7.62541 8.04652 7.90315 7.52499 7.90315C7.38613 7.90315 7.24726 7.88463 7.11456 7.84451L2.88683 6.63483V12.1278C2.88683 12.5814 3.19542 12.9764 3.63363 13.0844L10.3054 14.7539C10.6202 14.8311 10.9504 14.8311 11.2621 14.7539L17.94 13.0844C18.3782 12.9733 18.6868 12.5783 18.6868 12.1278V6.63483L14.4591 7.84143C14.3264 7.88155 14.1875 7.90006 14.0487 7.90006ZM20.6094 4.43764L19.0201 1.26529C18.9244 1.07397 18.7177 0.962873 18.5048 0.990646L10.7868 1.97506L13.6166 6.66877C13.7339 6.86319 13.9684 6.95576 14.1875 6.89405L20.2946 5.15049C20.6001 5.061 20.7482 4.72155 20.6094 4.43764ZM2.55355 1.26529L0.96429 4.43764C0.822336 4.72155 0.973547 5.061 1.27597 5.1474L7.38304 6.89096C7.60214 6.95268 7.83667 6.8601 7.95394 6.66569L10.7868 1.97506L3.06581 0.990646C2.85288 0.965959 2.64921 1.07397 2.55355 1.26529Z"
                fill="#383F51" />
            </svg>
          </i>
          Light Package
          <span></span>
        </label>

        <label :for="'yesEnd' + index" class="radio-label">
          <input type="radio" v-model="shipPackages.shipmentType" value="heavy" :id="'yesEnd' + index"
            :name="'routeEnd' + index" @input="getShippingtypeValue(index, 'clear')" />
          <i class="mx-2">
            <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M24.3798 11.25H20.9076V15L19.5187 14.168L18.1298 15V11.25H14.6576C14.2756 11.25 13.9631 11.5312 13.9631 11.875V19.375C13.9631 19.7188 14.2756 20 14.6576 20H24.3798C24.7617 20 25.0742 19.7188 25.0742 19.375V11.875C25.0742 11.5312 24.7617 11.25 24.3798 11.25ZM7.71311 8.75H17.4353C17.8173 8.75 18.1298 8.46875 18.1298 8.125V0.625C18.1298 0.28125 17.8173 0 17.4353 0H13.9631V3.75L12.5742 2.91797L11.1853 3.75V0H7.71311C7.33116 0 7.01866 0.28125 7.01866 0.625V8.125C7.01866 8.46875 7.33116 8.75 7.71311 8.75ZM10.4909 11.25H7.01866V15L5.62977 14.168L4.24089 15V11.25H0.768663C0.386719 11.25 0.0742188 11.5312 0.0742188 11.875V19.375C0.0742188 19.7188 0.386719 20 0.768663 20H10.4909C10.8728 20 11.1853 19.7188 11.1853 19.375V11.875C11.1853 11.5312 10.8728 11.25 10.4909 11.25Z"
                fill="black" />
            </svg>
          </i>
          Cargo/Heavy Package
          <span></span>
        </label>

        <label :id="'yesFinish' + index" class="radio-label">
          <input type="radio" v-model="shipPackages.shipmentType" value="truck" :id="'yesFinish' + index"
            :name="'routeEnd' + index" @input="getShippingtypeValue(index, 'clear')" />
          <i class="mx-2">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.3272 12.4167C13.9957 12.4167 13.6777 12.285 13.4433 12.0505C13.2089 11.8161 13.0772 11.4982 13.0772 11.1667C13.0772 10.8351 13.2089 10.5172 13.4433 10.2828C13.6777 10.0484 13.9957 9.91666 14.3272 9.91666C14.6587 9.91666 14.9766 10.0484 15.2111 10.2828C15.4455 10.5172 15.5772 10.8351 15.5772 11.1667C15.5772 11.4982 15.4455 11.8161 15.2111 12.0505C14.9766 12.285 14.6587 12.4167 14.3272 12.4167ZM15.5772 4.91666L17.2105 6.99999H13.4939V4.91666H15.5772ZM4.32719 12.4167C3.99567 12.4167 3.67773 12.285 3.44331 12.0505C3.20888 11.8161 3.07719 11.4982 3.07719 11.1667C3.07719 10.8351 3.20888 10.5172 3.44331 10.2828C3.67773 10.0484 3.99567 9.91666 4.32719 9.91666C4.65871 9.91666 4.97665 10.0484 5.21107 10.2828C5.44549 10.5172 5.57719 10.8351 5.57719 11.1667C5.57719 11.4982 5.44549 11.8161 5.21107 12.0505C4.97665 12.285 4.65871 12.4167 4.32719 12.4167ZM15.9939 3.66666H13.4939V0.333328H1.82719C0.902189 0.333328 0.160522 1.07499 0.160522 1.99999V11.1667H1.82719C1.82719 11.8297 2.09058 12.4656 2.55942 12.9344C3.02826 13.4033 3.66415 13.6667 4.32719 13.6667C4.99023 13.6667 5.62611 13.4033 6.09496 12.9344C6.5638 12.4656 6.82719 11.8297 6.82719 11.1667H11.8272C11.8272 11.8297 12.0906 12.4656 12.5594 12.9344C13.0283 13.4033 13.6641 13.6667 14.3272 13.6667C14.9902 13.6667 15.6261 13.4033 16.095 12.9344C16.5638 12.4656 16.8272 11.8297 16.8272 11.1667H18.4939V6.99999L15.9939 3.66666Z"
                fill="#383F51" />
            </svg>
          </i>
          Haulage
          <span></span>
        </label>
      </div>

      <div class="flex justify-between flex-wrap" v-if="isLight(shipPackages.shipmentType)">
        <p class="sm:w-5/12 w-full text-red-500 mt-2">
          * Items dimension should be less or equal to 50cm x 40cm x 40cm and
          the gross weight should weigh 32kg or less.
        </p>
        <button class="px-4 py-1 border-2 mt-2 border-gray-300" @click="showGuide">
          See Package Guidelines
        </button>
      </div>
      
      <!-- start shadow section -->
      <div class="p-3 flex justify-between flex-wrap rounded-lg bx-box">
        <div class="sm:w-5/12 w-full" v-if="isTruck(shipPackages.shipmentType)">
          <label class="label">Truck Capacity</label>
          <el-select filterable v-model="shipPackages.cargoCapacity" placeholder="Select handling requirements">
            <el-option v-for="truck in truckCapacity" :key="truck" :label="truck" :value="truck">
            </el-option>
          </el-select>
        </div>

        <div class="sm:w-5/12 w-full" v-if="!isLight(shipPackages.shipmentType)">
          <label class="label">Shipment Category</label>
          <el-select filterable v-model="shipPackages.shipmentCategory" placeholder="Select">
            <el-option v-for="catagory in shippmentCategory" :key="catagory" :label="catagory" :value="catagory">
            </el-option>
          </el-select>
        </div>

        <div class="sm:w-5/12 w-full" v-if="isLight(shipPackages.shipmentType)">
          <label class="label">Shipment Category</label>
          <el-select filterable v-model="shipPackages.shipmentCategory" placeholder="Select">
            <el-option v-for="catagory in lightCategory" :key="catagory" :label="catagory" :value="catagory">
            </el-option>
          </el-select>
        </div>

        <div class="sm:w-5/12 w-full" v-if="!isLight(shipPackages.shipmentType)">
          <div class="flex justify-between items-center">
            <label class="label">Package Type</label>
            <span class="small-text">(All items are of a similar Dimension)</span>
          </div>
          <el-select filterable v-model="shipPackages.packageType"
            placeholder="Select handling requirements">
            <el-option v-for="type in ['Boxed', 'Sacked', 'Crated', 'Pallet']" :key="type" :label="type" :value="type">
            </el-option>
          </el-select>
        </div>

        <div class="sm:w-5/12 w-full">
          <label class="label">Shipment Description</label>
          <input v-model="shipPackages.description" type="text" placeholder="Describe its content"
            class="w-full p-2 text-field" />
        </div>
        <div class="sm:w-5/12 w-full" v-if="!isLight(shipPackages.shipmentType)">
          <label class="label">Unit for Weight</label>
          <el-select v-model="shipPackages.unitOfWeight" placeholder="Select Type">
            <el-option label="milligram" value="mg"></el-option>
            <el-option label="gram" value="g"></el-option>
            <el-option label="kilogram" value="kg"></el-option>
            <el-option label="ounce" value="oz"></el-option>
            <el-option label="pound" value="lb"></el-option>
            <el-option label="metric tonne" value="mt"></el-option>
            <el-option label="ton" value="t"></el-option>
          </el-select>
        </div>
        <div class="sm:w-5/12 w-full" v-if="!isLight(shipPackages.shipmentType)">
          <label class="label">Unit for Dimensions</label>
          <el-select v-model="shipPackages.unitOfDimension" placeholder="Select Type">
            <el-option label="millimeter" value="mm"></el-option>
            <el-option label="centimeter" value="cm"></el-option>
            <el-option label="meter" value="m"></el-option>
            <el-option label="kilometer" value="km"></el-option>
            <el-option label="inch" value="in"></el-option>
            <el-option label="feet" value="ft"></el-option>
            <el-option label="yard" value="yd"></el-option>
          </el-select>
        </div>

        <div class="sm:w-5/12 w-full" v-if="!isLight(shipPackages.shipmentType)">
          <label class="label">Total estimated weight({{ shipPackages.unitOfWeight }})</label>
          <input type="number" v-model="shipPackages.estimatedWeight" placeholder="Enter"
            class="w-full p-2 text-field" />
          <span class="text-sm italic text-gray-500">
            Final shipment cost is subject to weight confirmation by our
            agent</span>
        </div>

        <div class="sm:w-5/12 w-full">
          <label class="label">Quantity</label>
          <input type="number" v-model="shipPackages.quantity" placeholder="Specify quantity"
            class="w-full p-2 text-field" />
        </div>

        <div class="w-full" v-if="!isLight(shipPackages.shipmentType)">
          <div class="flex items-center flex-wrap justify-between">
            <div class="dim_width">
              <label class="label">Item Length ({{ shipPackages.unitOfDimension }})</label>
              <input type="number" v-model="shipPackages.length" placeholder="Specify" class="p-2 text-field mr-1" />
            </div>

            <div class="dim_width">
              <label class="label">Item Width ({{ shipPackages.unitOfDimension }})</label>
              <input type="number" v-model="shipPackages.width" placeholder="Specify"
                class="p-2 text-field dim_width mx-1" />
            </div>

            <div class="dim_width">
              <label class="label">Item Height ({{ shipPackages.unitOfDimension }})</label>
              <input type="number" placeholder="Specify" v-model="shipPackages.height"
                class="p-2 text-field dim_width ml-1" />
            </div>
          </div>
        </div>

        <div class="sm:w-5/12 w-full">
          <label class="label">Total Value of Items (NGN)</label>
          <input type="number" v-model="shipPackages.itemValue" placeholder="Enter item value"
            class="w-full p-2 text-field" />
          <span class="text-sm italic text-gray-500">Insurance will only cover declared value</span>
          <span class="block w-full text-red-500 text-sm"
          v-if="Number(shipPackages.itemValue) <= 0"
          >The total value must be greater than zero</span>
        </div>

        <div class="sm:w-5/12 w-full">
          <div class="flex justify-between items-center mt-4">
            <label class="label whitespace-no-wrap">Special handling?</label>
            <div class="w-full flex mt-1 gap-4 justify-end">
              <label :for="'handlingNo' + index" class="radio-label">
                <input class="bg-primary-yellow text-secondary-yellow" :name="'handling' + index" type="radio"
                  :id="'handlingNo' + index" value="no" v-model="shipPackages.specialHandlingRadio" />
                No
                <span></span>
              </label>

              <label :for="'handlingYes' + index" class="radio-label">
                <input type="radio" v-model="shipPackages.specialHandlingRadio" value="yes" :id="'handlingYes' + index"
                  :name="'handling' + index" />
                Yes
                <span></span>
              </label>
            </div>
          </div>
          <el-select v-model="shipPackages.specialHandling" multiple
            :disabled="shipPackages.specialHandlingRadio == 'no'" placeholder="Special handling options">
            <el-option v-for="option in handlingOptions" :key="option.value" :label="option.title"
              :value="option.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <!-- end shadow section -->

    <!-- END of packaaage -->

    <div class="w-full px-4">
      <button @click="addToNewBookingStore" class="flex items-center ml-4 mt-5 pb-4">
        <img src="@/assets/images/icons/add.svg" alt="add icon" class="mr-2" />
        Save and Add Another
      </button>
      <hr class="border-b-2 w-full border-gray-400" />
    </div>

    <div class="flex items-center justify-between py-4 px-4">
      <button class="underline" @click="$emit('changeBookingTab', 2)">
        Back
      </button>

      <primary-button class="shadow-md font-normal" buttonText="Continue" :loading="loading" @click="submitPackage" />
    </div>

    <DeletePackageModal @close-modal="showDeleteModal = false" :showModal="showDeleteModal"
      @deletePackage="deletePackage" />

    <PackageGuidlineModal @close-modal="closeGuideModal" :showModal="showGuidelinemodal" />
  </div>
</template>

<script>
import PackageGuidlineModal from "../../modals/PackageGuidlineModal.vue";
import DeletePackageModal from "../../modals/DeletePackageModal.vue";

export default {
  data() {
    return {
      showGuidelinemodal: false,
      showDeleteModal: false,
      isSubmitted: [],
      loading: false,
      deleteId: "",
      deletePackageId: null,
      lockNext: false,
      packages: [
        {
          packageType: undefined,
          shipmentType: "light",
          shipmentCategory: undefined,
          description: undefined,
          quantity: undefined,
          itemValue: undefined,
          specialHandlingRadio: "no",
          length: 50,
          height: 50,
          width: 50,
          id: undefined,
          specialHandling: [],
          shippingId: this.$store.getters.latestNewInitialShipping?.id,
          cargoCapacity: undefined,
          estimatedWeight: 5,
          unitOfWeight: "kg",
          unitOfDimension: "cm",
        },
      ],
      truckCapacity: [
        "5 Ton",
        "10 Ton",
        "15 Ton",
        "20 Ton Flat Bed",
        "20 Ton Sided",
        "30 Ton Flat Bed",
        "30 Ton Sided",
        "40 Ton Flat Bed",
        "40 Ton Sided",
        "20ft Container",
        "40ft Container",
      ],
      shippmentCategory: [
        "Clothings/Shoes",
        "Computer Accessories",
        "Electronics",
        "Food",
        "Health Products",
        "Jewelries/Accessories",
        "Phones",
        "Others",
      ],
      lightCategory: ["Parcel", "Document", "Electronic Device", "Others"],
      handlingOptions: [
        { value: "fragile", title: "Fragile" },
        { value: "oversized", title: "Over-sized" },
        { value: "dangerous", title: "Dangerous" },
        { value: "packagehandling", title: "⁠Package-handling" },
        { value: "inflammable", title: 'inflammable' },
        { value: "⁠radioactive", title: "Radioactive" },
      ],
      declaredValue: "",
    };
  },
  components: { PackageGuidlineModal, DeletePackageModal },
  watch: {
    createdShipment() {
      // alert("sdn")
    },
  },
  computed: {
    shippingId() {
      return this.$store.getters.latestNewInitialShipping?.id;
    },
    payload() {
      return this.packages;
    },
  },
  mounted() {
    let storepackage = this.$store.getters?.latestNewBooking?.packages;
    if (!storepackage.length) return;

    let concatPackage = []
    storepackage.forEach((item) => {
      const Package = { ...this.packages[0], ...item }
      concatPackage.push(Package)
    });

    this.packages = concatPackage;
  },
  methods: {
    getShippingtypeValue(val, type) {
      if (type === 'default') {
        this.packages[val].length = 50
        this.packages[val].width = 50
        this.packages[val].height = 50
        this.packages[val].estimatedWeight = 5
      } else {
        this.packages[val].length = undefined
        this.packages[val].width = undefined
        this.packages[val].height = undefined
        this.packages[val].estimatedWeight = undefined
      }
    },
    async deletePackage() {
      if (!this.packages.length == 1) return;
      this.deletePackageId &&
        (await this.$_deletePackageInformation(this.deletePackageId));
      this.packages = this.packages.filter((item, index) => {
        return index !== this.deleteId;
      });
    },
    async setDeletePackageProps(val, id) {
      this.showDeleteModal = true;
      this.deleteId = val;
      this.deletePackageId = id;
    },
    async submitPackage() {
      this.loading = true;
      try {
        let response = await this.$_submitPackageInformation(this.payload);
        let clonePackages = this.packages
        response.data.packages.forEach((element, index) => {
          clonePackages[index].id = element.id
        });
        this.packages = clonePackages
        this.$store.dispatch("saveBookingChangesIndicator", true);
        this.$emit("changeBookingTab", 4);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async addToNewBookingStore() {
      try {
        // let response = await this.$_submitPackageInformation(this.payload);
        this.$store.dispatch(
          "saveLatestNewBookinPackages",
          this.payload
        );
        // this.packages = response.data.packages;
      } catch (error) {
        this.handleError(error);
      }

      this.packages.push({
        shipmentType: "light",
        shipmentCategory: null,
        description: null,
        quantity: null,
        itemValue: null,
        length: undefined,
        height: undefined,
        width: undefined,
        id: undefined,
        packageType: undefined,
        specialHandlingRadio: "no",
        specialHandling: [],
        shippingId: this.$store.getters.latestNewInitialShipping?.id,
        cargoCapacity: null,
        estimatedWeight: null,
        unitOfWeight: "kg",
        unitOfDimension: "cm",
      });
      this.isSubmitted.push(true);
      this.$store.dispatch("saveLatestNewBookinPackages", this.packages);
    },
    isLight(val) {
      return val == "light";
    },
    isHeavy(val) {
      return val == "heavy";
    },
    isTruck(val) {
      return val == "truck";
    },
    showGuide() {
      this.showGuidelinemodal = true;
    },
    closeGuideModal() {
      this.showGuidelinemodal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-text {
  font-size: 27px;
  @apply py-4 text-center pt-12;
}

.primary-button {
  @apply px-5 bg-primary-yellow py-3 rounded-md;
}

.single-option {
  @apply mx-2;
}

.dim {
  @apply px-2 py-2 border-2 border-gray-400 bg-gray-100;
  width: 32%;
}

.property {
  @apply px-2 py-2 border-2 border-gray-400 bg-gray-100 w-full;
}

.select-box {
  @apply flex items-center justify-between bg-gray-200 py-4 px-2 duration-300 cursor-pointer;
  width: 24%;
}

.select-box-active {
  @apply bg-primary-navy text-white;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  display: none;
}

.width {
  width: 25px;
}

.bx-box {
  @apply border-t-2 border-gray-200;
  margin: 6px;
  margin-top: 40px;
}

.bx-box:nth-of-type(1) {
  @apply border-t-2 border-transparent;
  margin: 6px;
  margin-top: 6px;
}

.radio-label {
  @apply flex items-center;
}

.text-field {
  @apply bg-gray-100 px-3 border-2 border-gray-200 rounded-sm;
}

.label {
  @apply mt-4;
}

.small-text {
  font-size: 12px;
  opacity: 0.65;
}

.dim_width {
  width: 32%;
  display: block;
}

.dim_width input {
  width: 100%;
}
</style>
